
export const AuthenticationMethod = {
  EMAIL_OTP: "email-otp",
  GMAIL: "gmail",
  AZURE_SSO_SAML: "azure-sso-saml",
  AWS_SSO_SAML: "aws-sso-saml",
};

export const AuthenticationMethodId = {
  EMAIL_OTP: 1,
  GMAIL: 2,
  AZURE_SSO_SAML: 3,
  AWS_SSO_SAML: 4,
};

export const getAuthenticationMethodLabelById = (id) => {
  const idToLabelMap = {
    [AuthenticationMethodId.EMAIL_OTP]: AuthenticationMethod.EMAIL_OTP,
    [AuthenticationMethodId.GMAIL]: AuthenticationMethod.GMAIL,
    [AuthenticationMethodId.AZURE_SSO_SAML]: AuthenticationMethod.AZURE_SSO_SAML,
    [AuthenticationMethodId.AWS_SSO_SAML]: AuthenticationMethod.AWS_SSO_SAML,
  };
  return idToLabelMap[id] || null;
};

